import React from 'react'
import { Navbar, Nav, Container, NavDropdown, Image } from 'react-bootstrap'
import { loginSuccess, logout } from '../slices/authSlice';
import { selectAuth } from '../slices/authSlice';
import { useSelector, useDispatch } from 'react-redux'
import { useNavigate } from 'react-router-dom';
import { logoutRequest } from '../slices/requests';
import axios from 'axios';
import userIcon from '../svg_assets/user.png';



const NavbarComponent = () => {
  const { isAuthenticated, userInformation } = useSelector(selectAuth);
  const dispatch = useDispatch()

  const navigate = useNavigate();
  const handleSignOut = async () => {
    // logoutRequest()
    try {
      const response = await axios.post('/api/logout');

      // If login is successful, save session status and redirect
      if (response.status === 200) {
        // Save session status if needed (e.g., using localStorage or context)
        // localStorage.setItem('session', JSON.stringify(response.data)); // Example
        //console.log(userInformation)
        dispatch(logout(response.data.id))
        navigate('/');  // Redirect to /home
      }
    } catch (error) {
      console.error(error);
    }
  };

  return (
    <Navbar expand="sm" bg="success" variant='dark' >
      <Container>
        <Navbar.Brand href="/">
          <img
            src="/assets/images/logo.png"
            alt='logo'
            height='30'
            onClick={() =>navigate('/')}
          />{' RNE 2025'}
          

        </Navbar.Brand>

        <Navbar.Toggle aria-controls="basic-navbar-nav" />
        <Navbar.Collapse id="basic-navbar-nav">

          <Nav className="ms-auto">
            <Nav.Item ><Nav.Link onClick={() =>navigate('/')} className="text-white">Home</Nav.Link></Nav.Item>
            <Nav.Item ><Nav.Link onClick={() =>navigate('/scoreboard')} className="text-white">Scoreboard</Nav.Link></Nav.Item>
            {isAuthenticated ?
              (
                <NavDropdown
                  title={
                    <>
                      <Image
                        src={userIcon} // Placeholder for the user icon
                        roundedCircle
                        style={{ width: '30px', height: '30px' }}
                        alt="User Icon"
                        className='mx-2'
                      />
                      {userInformation.patrouille ? userInformation.patrouille : userInformation.name}
                    </>
                  }
                  id="user-dropdown"
                  align="end"
                >
                  <NavDropdown.Header>{userInformation.patrouille ? userInformation.patrouille : userInformation.name}</NavDropdown.Header>
                  <NavDropdown.Divider />
                  {
                    userInformation.Branche?
                    (<NavDropdown.Item onClick={() =>navigate('/branche')}>
                      Branche Admin Page
                    </NavDropdown.Item>
                    ):
                    <></>
                  }
                  {
                    userInformation.CT?
                    (<NavDropdown.Item onClick={() =>navigate('/UploadsDefis')}>
                      View Uploads by Defi
                    </NavDropdown.Item>
                    ):
                    <></>
                  }
                  {
                    userInformation.CT?
                    (<NavDropdown.Item onClick={() =>navigate('/UploadsPatrouilles')}>
                      View Uploads by Patrouilles
                    </NavDropdown.Item>
                    ):
                    <></>
                  }
                  <NavDropdown.Item onClick={handleSignOut}>
                    Sign Out
                  </NavDropdown.Item>
                </NavDropdown>
              )
              :
              (
                <>
                <Nav.Item ><Nav.Link onClick={() =>navigate('/login')} className="text-white">Login</Nav.Link></Nav.Item>
                <Nav.Item ><Nav.Link onClick={() =>navigate('/loginBranche')} className="text-white">Login Branche</Nav.Link></Nav.Item>
                </>
              )
            }
            {/* <Nav.Item ><Nav.Link href="/admin" className="text-white">Admin</Nav.Link></Nav.Item> */}
          </Nav>
        </Navbar.Collapse>

      </Container>
    </Navbar>
  )
}

export default NavbarComponent;
